// Заглушки на время загрузки
import type { CSSProperties } from 'react';

export function Skeleton({ count = 1, style }: { count?: number; style?: CSSProperties }) {
  return <>{Array.from({ length: count }, (_, i) => <div key={i} className="skeleton" style={style} />)}</>;
}
